import { ComboInCart } from '../hooks/contexts/cart.context';
import { Ticket } from '../types/ticket';

const shouldDisableButton = ({
  isNamingPage,
  disableBtnInNamingPage,
  findMinimumTickets,
  cart,
  combosInCart,
  loading,
  cartLoading
}: {
    isNamingPage: boolean;
    disableBtnInNamingPage: boolean;
    findMinimumTickets: number;
    cart: Ticket[];
    combosInCart: ComboInCart[];
    loading: boolean;
    cartLoading: boolean;
  }) => {
  const isCartEmpty = cart.length === 0 && combosInCart.length === 0;
  const shouldDisableDueToCart = findMinimumTickets > -1 || isCartEmpty || loading || cartLoading;
  return isNamingPage ? disableBtnInNamingPage : shouldDisableDueToCart;
};

export default shouldDisableButton;
